module.exports = __webpack_public_path__ + "img/16581294_L.8d73e742.png";